<script>
  export let links;
</script>

{#each links as link, i}
  {#if i > 0}&nbsp;·&nbsp;{/if}
  <a href="{link.href}">{link.title}</a>
{/each}
